export default __webpack_public_path__ + "static/vegetable-59b98c306b97a82868af57a3c7207e89.webp";